export const languageCode = 'fr';
export const languageLabel = 'French';

export const translations = {
  AUDIO_DESCRIPTION_OFF: 'Fermer',

  CAPTIONS_BACK_TO_CAPTIONS_MENU: 'Back to captions menu',
  CAPTIONS_CAPTIONS_SETTINGS_RESET_DEFAULTS: 'Captions settings reset to defaults',
  CAPTIONS_CHARACTER_EDGE_STYLE: 'Character edge style',
  CAPTIONS_CHARACTER_EDGE_STYLE_CLOSE: 'Close character edge style menu',
  CAPTIONS_CHARACTER_EDGE_STYLE_OPEN: 'Open character edge style menu',
  CAPTIONS_CLOSE_TRANSCRIPT: 'Search Video - close transcript viewer',
  CAPTIONS_DISABLED: 'No captions available',
  CAPTIONS_FONT_FAMILY: 'Font family',
  CAPTIONS_FONT_FAMILY_CLOSE: 'Close Font Family Menu',
  CAPTIONS_FONT_FAMILY_OPEN: 'Open Font Family Menu',
  CAPTIONS_HIDE_MENU: 'Masquer le menu des sous-titres',
  CAPTIONS_OFF: 'Fermer',
  CAPTIONS_OPEN_TRANSCRIPT: 'Search Video - open transcript viewer',
  CAPTIONS_READ_TRANSCRIPT: 'Rechercher une vidéo',
  CAPTIONS_SHOW_MENU: 'Afficher le menu des sous-titres',
  CAPTIONS_TURN_OFF: 'Turn off captions',
  CAPTIONS_TURN_ON: 'Turn on captions',

  CHAPTERS_CLOSE_CHAPTERS: 'Fermer les chapitres',
  CHAPTERS_OPEN_CHAPTERS: 'Chapitres ouverts',

  CLICK_FOR_SOUND_DESKTOP_TEXT: 'Cliquez pour le son',
  CLICK_FOR_SOUND_MOBILE_TEXT: 'Appuyez pour le son',

  CONTEXT_MENU_ABOUT_WISTIA: 'À propos de Wistia',
  CONTEXT_MENU_COPIED: 'Copié!',
  CONTEXT_MENU_COPY_LINK_AND_THUMBNAIL: 'Copier le lien et la vignette',
  CONTEXT_MENU_LOGGED_IN_TO_WISTIA: 'Connecté à Wistia',
  CONTEXT_MENU_OPEN_VIDEO_IN_WISTIA: 'Ouvrir la vidéo dans Wistia',
  CONTEXT_MENU_REPORT_A_PROBLEM: 'Signaler un problème',
  CONTEXT_MENU_VIEW_STATS_IN_WISTIA: 'Voir les statistiques dans Wistia',

  CUSTOMER_LOGO_LOGO: 'Logo',

  ENTER_PASSWORD_PHRASE: 'Please enter your password.',

  FULLSCREEN_DOUBLE_TAP: 'Double-tap to zoom in or out',
  FULLSCREEN_TITLE_WHEN_IN_FULLSCREEN: 'Quitter le mode plein écran',
  FULLSCREEN_TITLE_WHEN_NOT_IN_FULLSCREEN: 'Plein écran',

  INCORRECT_PASSWORD: 'Incorrect Password',

  LAYOUT_TITLE: 'Vidéo',

  PASSWORD: 'Password',

  PLAY: 'Play',

  PLAY_BUTTON_LIVE_NOT_STARTED: 'Livestream has not started',
  PLAY_BUTTON_TITLE_WHEN_NOT_PLAYING: 'Lecture',
  PLAY_BUTTON_TITLE_WHEN_PLAYING: 'Pause',

  REPORT_A_PROBLEM_ADD_DETAILS_TEXT: 'Veuillez ajouter des détails',
  REPORT_A_PROBLEM_CANCEL: 'Cancel',
  REPORT_A_PROBLEM_CHOOSE_ONE: 'Choisissez-en un',
  REPORT_A_PROBLEM_DESCRIPTION:
    "Merci d'avoir signalé un problème. Nous joindrons des données techniques sur cette session pour nous aider à comprendre le problème. De quel problème s'agit-il?",
  REPORT_A_PROBLEM_DISMISS: 'Ignorer',
  REPORT_A_PROBLEM_FAILS_TO_PLAY: 'La vidéo ne fonctionne pas',
  REPORT_A_PROBLEM_OTHER: 'Autre',
  REPORT_A_PROBLEM_OTHER_CONTEXT: "D'autres détails ou contexte?",
  REPORT_A_PROBLEM_POOR_QUALITY: 'La qualité de la vidéo est médiocre',
  REPORT_A_PROBLEM_PROBLEM_CATEGORY: 'Catégorie de problème',
  REPORT_A_PROBLEM_PROBLEM_DESCRIPTION: 'Description du problème',
  REPORT_A_PROBLEM_SELECT_CAT_TEXT: 'Veuillez sélectionner une catégorie',
  REPORT_A_PROBLEM_SEND: 'Envoyer',
  REPORT_A_PROBLEM_SENDING: 'Envoi en cours...',
  REPORT_A_PROBLEM_STUTTER: 'La vidéo fonctionne mais la qualité fluctue souvent',

  REWATCH: 'Relire',

  SETTINGS_PLAYBACK_RATE_TITLE: 'Vitesse',
  SETTINGS_QUALITY_AUTO: 'Auto',
  SETTINGS_QUALITY_TITLE: 'Qualité',
  SETTINGS_TITLE: 'Settings',

  SHARE_CONTROL_CLOSE: 'Fermer le menu de partage',
  SHARE_CONTROL_OPEN: 'Ouvrir le menu de partage',
  SHARE_COPIED: 'Copié!',
  SHARE_DOWNLOAD: 'Télécharger',
  SHARE_EMAIL: 'Email',
  SHARE_EMBED: 'Intégrer',
  SHARE_FACEBOOK: 'Facebook',
  SHARE_LINKED_IN: 'LinkedIn',
  SHARE_TWITTER: 'Twitter',

  SKIP: 'Sauter',

  STATUS_BAR_EMBED_CODE_COPIED: 'Le code incorporé est maintenant copié dans votre presse-papiers!',

  THUMBNAIL_VIDEO_THUMBNAIL: 'Vignette vidéo',

  TURNSTILE_DEFAULT_END: "Merci d'avoir regardé la vidéo! \nVeuillez entrer votre adresse e-mail.",
  TURNSTILE_DEFAULT_START: 'Entrez votre adresse e-mail pour voir cette vidéo.',
  TURNSTILE_EMAIL_PLACEHOLDER: 'Votre adresse e-mail',
  TURNSTILE_FIRST_NAME_PLACEHOLDER: 'Prénom',
  TURNSTILE_LAST_NAME_PLACEHOLDER: 'Nom de famille',
  TURNSTILE_PLAY: 'Lecture',
  TURNSTILE_SUBMIT: 'Envoi',
  TURNSTILE_VENDOR_FIELD_ERROR: 'Please fill out ',

  VOLUME_TITLE_VOLUME_SLIDER: 'Curseur de réglage du volume',
  VOLUME_TITLE_WHEN_MUTED: 'Remettre le son',
  VOLUME_TITLE_WHEN_UNMUTED: 'Couper le son',
  WATCH_NEXT_NEXT_VIDEO_PLAYS_IN: 'La prochaine vidéo commence dans...',
};
